import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Handle, Position } from '@xyflow/react';
import { clsx } from 'clsx';
import ValueChainGroupItem from 'components/ValueChainGroupItem/ValueChainGroupItem';

import type { ICustomGroupNode } from '../interfaces/ICustomGroupNode';

import styles from '../sass/CustomGroupNode.module.scss';

function CustomGroupNode({ data }: ICustomGroupNode) {
  const { t } = useTranslation();
  const {
    groupId, title, count, cardType, isExpanded, onToggleGroup,
  } = data;

  const handleToggle = () => {
    onToggleGroup(groupId);
  };

  return (
    <div className={styles.wrapper}>
      <Handle
        type="target"
        position={Position.Left}
        className={styles.handle}
        isConnectable={false}
      />
      <Handle
        type="source"
        position={Position.Right}
        className={styles.handle}
        isConnectable={false}
      />
      <span className={clsx(styles.dot, styles.dotLeft)} aria-hidden />
      <span className={clsx(styles.dot, styles.dotRight)} aria-hidden />
      <ValueChainGroupItem
        title={title}
        count={count}
        cardType={cardType}
        isExpanded={isExpanded}
        onToggle={handleToggle}
        className={clsx('nopan', 'nodrag')}
      />
      {isExpanded ? (
        <p className={styles.hint}>{t('valueChainMap.groupCollapseHint')}</p>
      ) : null}
    </div>
  );
}

export default memo(CustomGroupNode);
